import Chip from '@mui/material/Chip';

const STATUS_STYLES = {
  denied:    { bgcolor: '#FDECEA', color: '#C62828', fontWeight: 600 },
  underpaid: { bgcolor: '#FFF3E0', color: '#E65100', fontWeight: 600 },
  paid:      { bgcolor: '#E8F5E9', color: '#2E7D32', fontWeight: 600 },
};

export default function LineStatusPill({ status }) {
  const style = STATUS_STYLES[status] || STATUS_STYLES.paid;
  const label = status ? status.charAt(0).toUpperCase() + status.slice(1) : 'Unknown';
  return (
    <Chip
      label={label}
      size="small"
      sx={{ ...style, borderRadius: '4px', height: 22, fontSize: '0.7rem' }}
    />
  );
}
